import React, { useState, useEffect, useRef } from "react";
import { Col, FormGroup, Input, Label, Button, Row, InputGroup, InputGroupText } from "reactstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import Tooltip from "react-tooltip-lite";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import useAxios from 'hooks/useAxios';
import { dateFormate } from 'utils/columns';
import { toast } from "react-toastify";
import { json } from "d3";
import save from "assets/icon/save.svg";
import AddWholeSaler from "assets/icon/AddWholeSaler.svg"
import HoverImage from "react-hover-image/build";

let hasDatePopupOpen = false;
const initialValues = {
  coveredEntity: "",
  pharmacy: "",
  tpa: "",
};

const Ordering = ({data, rowData}) => {
  const API = useAxios();
  const [tableData, setTableData] = useState(data);
  const [isdiable, setdiable] = useState(true);
  const [appdisable, setAppdisable] = useState(true);
  const [lookBackPeriod, setlookBackPeriod] = useState(data.lookBackPeriod);
  const [contractLive, setContractLive] = useState(false)
  const [state, updateState] = useState({
    initialValues: {
      checkLookBackPeriod: true,
      C2D: false,
      C3D: false,
      C4D: false,
      C5D: false,
      cashCardStatus: false,
      cashCardWindow: "",
      checkLookBackPeriod: true,
      contractLiveDate: true,
      DISP: 0,
      DCL: false,
      DEC: false,
      duplicateRxCheck: true,
      LBP: 0,
      OSD: "",
      otc: false,
      pharmacyStatus: true,
      profitRule: false,
      profitThreshold: "$ 0.00",
      reprocessing: false,
      reprocessingWindow: "",
      SIC: false,
      VDC: false,
      OGT: "",
      OGAT: "",
      OTC: false,
      NIOCD:0
    }
  });
  const formikRef = useRef();

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const { initialValues } = state;

  useEffect(() => {
    if (data !== undefined && data.length > 0) {
      setdiable(false);
      let temp = state;
      for (var x in data) {
        var code = data[x].code;
        if (code === "OSD" || code === "DISP" ) {
          temp.initialValues[code] = data[x].defaultConfigValue;
        }
        else if (code === "LBP") {
          temp.initialValues[code] = parseInt(data[x].defaultConfigValue);
        }
        else if (code == "OGT") {
          var val = data[x].defaultConfigValue == "S" ? 2 : 1;
          temp.initialValues[code] = val;
        }
        else if (code == "OGAT") {
          var val = data[x].defaultConfigValue == "M" ? 2 : 1;
          temp.initialValues[code] = val;
        }
        else if (code === "NIOCD") {
          temp.initialValues[code] = parseInt(data[x].defaultConfigValue);
        }
        else {
          var val = data[x].defaultConfigValue == "Y" ? true : false;
          temp.initialValues[code] = val;
        }
      }
      setState(temp);
    }
    else
      setdiable(true);
    setTableData(data);


    //   setState({
    //     initialValues: {
    //       checkLookBackPeriod:data.checkLookBackPeriod,
    //       c2DrugCheck:data.c2DrugCheck,
    //       c3DrugCheck:data.c3DrugCheck,
    //       c4DrugCheck:data.c4DrugCheck,
    //       c5DrugCheck:data.c5DrugCheck,
    //       cashCardStatus:data.cashCardStatus,
    //       cashCardWindow:data.cashCardWindow,
    //       checkLookBackPeriod:data.checkLookBackPeriod,
    //       contractLiveDate:data.contractLiveDate,
    //       dispensingfeeCheck:data.dispensingfeeCheck,
    //       drugClassCheck:data.drugClassCheck,
    //       drugExclusionCheck:data.drugExclusionCheck,
    //       duplicateRxCheck:data.duplicateRxCheck,
    //       lookBackPeriod:data.lookBackPeriod,
    //       orderingStartDate:data.orderingStartDate,
    //       otc:data.otc,
    //       pharmacyStatus:data.pharmacyStatus,
    //       profitRule:data.profitRule,
    //       profitThreshold:"$ 0.00",
    //       reprocessing:data.reprocessing,
    //       reprocessingWindow:"",
    //       supplyCheck:data.supplyCheck,
    //       vaccineCheck:data.vaccineCheck,
    //       orderGenerationType:data.orderGenerationType
    //     }
    // });
  }, [data]);

  const lookBackPeriodOpt = [
    { lookBackPeriod: 30, label: "30 Days" },
    { lookBackPeriod: 60, label: "60 Days" },
    { lookBackPeriod: 90, label: "90 Days" },
    { lookBackPeriod: 120, label: "120 Days" },
  ];

  const reportOpt = [
    { id: 30, label: "30 Days" },
    { id: 60, label: "60 Days" },
    { id: 90, label: "90 Days" },
    { id: 120, label: "120 Days" },
  ];

  const orderGenerationOpt = [
    { id: 1, label: "Auto Generate/Replenishment" },
    { id: 2, label: "PO Split" },
  ];


  const autoGeneratedPOApprovalOPt = [
    { id: 1, label: "Always Auto Approve" },
    { id: 2, label: "Never Approve" },
  ];

  const NotInvoicedOrdersCancelDays = [
    { id:"", label: "--Select--"},
    { id: 15, label: "15 Days" },
    { id: 30, label: "30 Days" },
    { id: 60, label: "60 Days" },
    { id: 90, label: "90 Days" },
  ];
  const validationSchema = Yup.object({
    coveredEntity: Yup.string().required("Required"),
  });


  const handleSaveConfig = async () => {
    let frk = formikRef.current.values;
    var param = {};
    var arrData = [];
    var arr = {};
    // arr.code = "SIC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["SIC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "VDC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["VDC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "LBP";
    // arr.description = "";
    // arr.defaultConfigValue = frk["LBP"];
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C2D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C2D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C3D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C3D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C4D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C4D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "C5D";
    // arr.description = "";
    // arr.defaultConfigValue = frk["C5D"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "DCL";
    // arr.description = "";
    // arr.defaultConfigValue = frk["DCL"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "DEC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["DEC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "OTC";
    // arr.description = "";
    // arr.defaultConfigValue = frk["OTC"] == true ? "Y" : "N";
    // arrData.push(arr);

    // arr = {};
    // arr.code = "DISP";
    // arr.description = "";
    // arr.defaultConfigValue = 0;
    // arrData.push(arr);

    arr = {};
    arr.code = "NIOCD";
    arr.description = "";
    arr.defaultConfigValue = frk["NIOCD"] == 0 ? null : frk["NIOCD"] ;
    arrData.push(arr);

    arr = {};
    arr.code = "OSD";
    arr.description = "";
    arr.defaultConfigValue = frk["OSD"];
    arrData.push(arr);

    arr = {};
    arr.code = "OGT";
    arr.description = "";
    arr.defaultConfigValue = frk["OGT"] == "1" ? "A" : "S";
    arrData.push(arr);

    arr = {};
    arr.code = "OGAT";
    arr.description = "";
    arr.defaultConfigValue = frk["OGAT"] == "1" ? "A" : "M";
    arrData.push(arr);

    param.JsonStr = arrData;

    try {
      const { data } = await API.post(`GWConfig/Configuration/SaveOrderContractConfig/${rowData.thirdPartyAdminID}/${rowData.ceid}/${rowData.phid}`, param, {
        hasDefaultURL: true,
      });
      if (data) {
        toast.success("Configurations saved successfully.");
        onHandleReset();
        handleReset();
      } else {
        toast.error("An error occurred");
        //setData([]);
        //setTotalItem(0);
      }
    } catch (error) { }
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleReset = () => {
    setState({
      initialValues: {
        checkLookBackPeriod: true,
        C2D: false,
        C3D: false,
        C4D: false,
        C5D: false,
        cashCardStatus: false,
        cashCardWindow: "",
        checkLookBackPeriod: true,
        contractLiveDate: true,
        DISP: 0,
        DCL: false,
        DEC: false,
        duplicateRxCheck: true,
        LBP: 0,
        OSD: "",
        otc: false,
        pharmacyStatus: true,
        profitRule: false,
        profitThreshold: "$ 0.00",
        reprocessing: false,
        reprocessingWindow: "",
        SIC: false,
        VDC: false,
        OGT: "",
        OGAT: "",
        NIOCD:0,
      }
    });
  }

  const handleChange = event => {
    setMessage(event.target.value);
  };

  const handleSwitchChange = (e, val) => {
    let frk = formikRef.current.values;
    if (val == "NIOCD") {
      const inputValue = e.target.value;
      const numericValue = parseInt(inputValue, 10);
      if (numericValue >= 1 && numericValue <= 365) {
        frk[val] = e.target.value;
      } else {
        frk[val] = "";
      }
    }
    if (val == "LBP" || val == "OGT" || val == "OGAT") {
      frk[val] = e.target.value;
    }
    else if (val == "OSD") {
      frk[val] = dateFormate(e);
    }
    // else {
    //   frk[val] = e.target.checked;
    // }
    setState({
      initialValues: frk
    });
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      innerRef={formikRef}
      children={(props) => {
        // const { isSubmitting, handleSubmit } = props;
        return (
          <div>
            <div className="mt-3">
              <Row>
                <Col md="3" className="">
                  <Label className=" mt-2">Ordering Start Date</Label>
                  <FormGroup >
                    <InputGroup>
                      <Field
                        type="text"
                        id="OSD"
                        name="OSD"
                        autoComplete="off"
                        placeholder="--Select--"
                        component={FormikDatePicker}
                        value={initialValues.OSD || ""}
                        disabled={isdiable}
                        onChange={(e) => handleSwitchChange(e, 'OSD')}
                      />
                      <InputGroupText
                        onClick={() => handleDateClick("OSD")}
                      >
                        <img src={Calendar} alt="" />
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md="3">
                  <div className="">
                    <Label className=" mt-2" for="orderGenerationType">Order Generation Type</Label>
                    {" "}
                    <FormGroup >
                      <Field
                        id="OGT"
                        name="OGT"
                        type="text"
                        autoComplete="off"
                        component={FormikSelectField}
                        disabled={isdiable}
                        defaultoption="--Select--"
                        value={initialValues.OGT || ""}
                        options={orderGenerationOpt}
                        onChange={(e) => handleSwitchChange(e, 'OGT')}
                        keys={{
                          id: "id",
                          label: "label",
                        }}
                      />
                    </FormGroup>
                  </div>
                </Col>
                <Col md="3">
                  <div className="">
                    <Label className="mt-2" for="autoGeneratedPOApproval">Auto Generated PO Approval</Label>
                    {" "}
                    <FormGroup >
                      <Field
                        id="OGAT"
                        name="OGAT"
                        type="text"
                        autoComplete="off"
                        component={FormikSelectField}
                        disabled={isdiable}
                        defaultoption="--Select--"
                        value={initialValues.OGAT || ""}
                        options={autoGeneratedPOApprovalOPt}
                        onChange={(e) => handleSwitchChange(e, 'OGAT')}
                        keys={{
                          id: "id",
                          label: "label",
                        }}
                      />
                    </FormGroup>
                  </div>
                </Col>
                <Col md="3">
                  <div className="">
                    <Label className="mt-2" for="orderInvoiceWaitingDays">Pending Order Cancellation Threshold  
                      
                       <Tooltip
                      content={
                        <div className="tip-list-info" style={{right:0}} >
                          <p>
                            {/* <strong>Acct# :</strong> */}
                            <span>
                              This configuration controls the number of days an item or order can remain uninvoiced before it is automatically cancelled. Once the set number of days has passed, any uninvoiced items will be cancelled and the inventory will be returned to accumulations, making it available for future orders.

                            </span>
                          </p>
                        </div>
                      }
                      direction="up"
                      tagName="span"
                      className="target"
                      tipContentClassName=""
                      zIndex={99999}
                    >
                      <span className="cursor-pointer text-decoration-underline">
                        <HoverImage
                          src={AddWholeSaler}
                          hoverSrc={AddWholeSaler}
                       className="tooltipInCofig"  
                          
                        ></HoverImage>
                      </span>
                    </Tooltip>
                  
                       </Label> 

                    {" "}
                    <FormGroup >
                      <Input
                        id="NIOCD"
                        name="NIOCD"
                        type="number"
                        autoComplete="off"
                        className="no-arrows"
                        placeholder='Enter Number Of Days'
                        disabled={isdiable}
                        min={1}
                        max={365}
                        value={initialValues.NIOCD || ""}
                        onChange={(e) => handleSwitchChange(e, 'NIOCD')}
                        onKeyDown={(e)=>{
                          if(["-" ,"." ,",", "+"].includes(e.key)){
                            e.preventDefault();
                          }
                        }}
                        keys={{
                          id: "id",
                          label: "label",
                        }}
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
              <Row>
              </Row>
              <Row className="d-flex justify-content-end">
                <Col md="auto" className="mt-1">
                  <Button disabled={isdiable} onClick={handleSaveConfig} color="primary" className="search">
                    <span className="right_5">
                      <img src={save} alt="" />
                    </span>{" "}
                    Save
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        );
      }}
    ></Formik>
  );
};
export default Ordering;
